import { Children } from "react";
import "./index.css";
import { ImgURL } from "../../../globalData";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import api from "../../../apis";
import { useQuery } from "@tanstack/react-query";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { Container } from "reactstrap";

const apiFn = (albumId) => api.teamGallery.getTeamGallery(albumId);

export default function GalleryDetails() {
  const { id, galleryId } = useParams();

  const { isLoading, isError, data } = useQuery({
    queryKey: ["gallery-album-images", galleryId, id],
    queryFn: () => apiFn(galleryId),
    select: ({ data }) => data.reverse(),
    refetchOnWindowFocus: false,
  });

  return (
    <div className='gallery-details-page'>
      <Container>
        <ul className='album-images'>
          {isLoading &&
            Children.toArray(
              [...Array(6).keys()].map(() => (
                <li className='image-item'>
                  <SkeletonTheme color='#004f90' highlightColor='#fff'>
                    <figure>
                      <Skeleton height={220} width={"100%"} duration={3} />
                    </figure>
                  </SkeletonTheme>
                </li>
              )),
            )}
          {!isLoading &&
            !isError &&
            Children.toArray(
              data.map(({ image }) => (
                <li className='image-item'>
                  <figure>
                    <img src={ImgURL(image)} alt='album-img' />
                  </figure>
                </li>
              )),
            )}
        </ul>
      </Container>
    </div>
  );
}
